/**
 * DOM Utils
 */

import * as React from 'react';

export function preventDefault(e: Event | React.MouseEvent) {
  e.preventDefault();
}

export function stopPropagation(e: Event | React.MouseEvent) {
  e.stopPropagation();
}

export function deactivateTouchMove() {
  document.addEventListener('touchmove', preventDefault, {
    capture: false,
    passive: false,
  });
}

export function reactivateTouchMove() {
  document.removeEventListener('touchmove', preventDefault);
}

export function getRelativeCoordinates(container, e) {
  const pos = {
    x: !!e.touches ? e.touches[0].pageX : e.pageX,
    y: !!e.touches ? e.touches[0].pageY : e.pageY,
  };
  const offset = {
    left: container.offsetLeft,
    top: container.offsetTop,
  };
  let ref = container.offsetParent;

  while (ref) {
    offset.left += ref.offsetLeft;
    offset.top += ref.offsetTop;
    ref = ref.offsetParent;
  }

  return {
    x: pos.x - offset.left,
    y: pos.y - offset.top,
  };
}

export function outerHeight(el) {
  let height = el.offsetHeight;
  const style = getComputedStyle(el);

  height += parseInt(style.marginTop!, 10) + parseInt(style.marginBottom!, 10);
  return height;
}

export function isElementUnder(el: Node, parentEl: Node) {
  if (el.parentNode) {
    if (el.parentNode === parentEl) {
      return true;
    }

    return isElementUnder(el.parentNode, parentEl);
  }

  return false;
}

export function simulateClick(elem) {
  const evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window,
  });
  elem.dispatchEvent(evt);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/dom.ts